import styled, { keyframes } from "styled-components";
import fipayFonts from "../../theme/index";

const slideIn = keyframes`
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  width: 90%;
  height: 80px;
  justify-content: space-between;
  align-items: center;
  animation: ${slideIn} 1s ease-in-out;

  .outsideClick {
    position: absolute;
    top: 200%;
  }
  @media screen and (min-width: 0px) and (max-width: 766px) {
    // margin-right: 80px;
    padding-top: 40px;
    padding-right: 20px;
    width: 90%;
    height: auto;
  }

  .mobile_small_screen {
    display: none;
    @media screen and (min-width: 0px) and (max-width: 766px) {
      .menu-button {
        /* padding-left: 220px; */
      }
    }

    .sidebar {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media screen and (min-width: 700px) {
        display: none;
      }
    }
    @media screen and (max-width: 700px) {
      display: block;
    }
    .mobile-list-nav {
      color: white;
      display: flex;
      align-items: center;
      list-style: none;
      justify-content: space-between;
      width: 300px;
      height: 50px;
      margin: 4px;

      a {
        text-decoration: none;
        color: #222;
      }
    }
    .join_waitList {
      background-color: #00a603;
      padding: 10px 30px;
      border-radius: 30px;
      border: none;
      color: white;
      font-family: "GT Walsheim Pro";
      font-size: ${fipayFonts.fipayFonts.fontSize.body2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
      line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
      letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
      margin-left: 30px;
    }
    .join_waitList:hover {
      background-color: #80e381;
    }
  }

  .fipay_img {
    cursor: pointer;
  }

  .tab_screen {
    display: none;
    @media screen and (min-width: 767px) and (max-width: 1024px) {
      display: block;
      .menu-button {
        padding-left: 500px;
      }
    }

    .sidebar {
      display: flex;
      flex-direction: column;
      align-items: center;

      @media screen and (min-width: 700px) {
        display: none;
      }
    }

    .mobile-list-nav {
      color: white;
      display: flex;
      align-items: center;
      list-style: none;
      justify-content: space-between;
      width: 300px;
      height: 50px;
      margin: 4px;
      a {
        text-decoration: none;
        color: #222;
      }
    }
    .join_waitList {
      background-color: #00a603;
      padding: 10px 30px;
      border-radius: 30px;
      border: none;
      color: white;
      font-family: "GT Walsheim Pro";
      font-size: ${fipayFonts.fipayFonts.fontSize.body2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
      line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
      letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
      margin-left: 30px;
    }
    .join_waitList:hover {
      background-color: #80e381;
    }
  }

  .ul-nav {
    display: flex;
    align-items: center;
    list-style: none;
    justify-content: space-between;
    width: 50%;
    @media screen and (min-width: 767px) and (max-width: 1025px) {
      display: none;
    }
    @media screen and (min-width: 0px) and (max-width: 766px) {
      display: none;
    }

    li {
      a {
        text-decoration: none;
        color: #363636;
        font-family: GT Walsheim Pro;
        font-size: 14px;
        font-weight: 400;

        text-align: left;
        position: relative;
        transition: all 0.3s ease-in-out;
        display: flex;
        align-items: center;
        &:hover {
          color: #00c703;
          text-decoration: none;

          &:after {
            content: "";
            position: absolute;
            width: 100%;
            height: 4px;
            background-color: #00c703;
            bottom: -10px;
            left: 0;
          }
        }
      }
    }
  }

  .Products {
    color: #363636;
    font-family: GT Walsheim Pro;
    font-size: 14px;
    font-weight: 400;
    line-height: 240px;
  }

  .arrow {
    margin-left: 7px;
    font-size: 13px;
    margin-bottom: -2px;
  }

  .arrow:hover {
    cursor: pointer;
    color: #00c703;
  }

  .nav_Btn {
    display: flex;
    align-items: center;
    // gap: 2rem;
    position: relative;

    @media screen and (max-width: 700px) {
      display: none;
    }

    .join_waitList {
      background-color: #00a603;
      padding: 10px 30px;
      border-radius: 30px;
      border: none;
      color: white;
      font-family: "GT Walsheim Pro";

      font-size: ${fipayFonts.fipayFonts.fontSize.body2};
      font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
      line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
      letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
      // margin-left: 10px;
      cursor: pointer;
      transition: background-color 0.3s ease;
      .join_waitList:hover {
        background-color: #80e381;
      }
      @media screen and (min-width: 767px) and (max-width: 1025px) {
        display: none;
      }
    }
    .join_waitList:hover {
      background-color: #80e381;
    }
  }

  button {
    color: #00c703;
    border-radius: 30px;
    font-family: GT Walsheim Pro;
    font-size: ${fipayFonts.fipayFonts.fontSize.body2};
    font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
    line-height: ${fipayFonts.fipayFonts.lineHeight.body3};
    letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body};
  }
  .open {
    max-width: 45%;
    max-height: 400px;
    background: white;
    position: fixed;
    border-radius: 10px;
    padding-left: 20px;
    top: 60px;
    display: flex;
    flex-wrap: wrap;

    .icon-open {
      height: 60px;
      margin: 10px;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .open-div {
        width: 50px;
        height: 50px;
        background: #f8f8f8;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 10px;
      }
      .btn {
        padding: 0px;
        margin: 0px;
        background-color: red;
        border: none;
        color: #00c703;
      }
      .navIcon_name {
        width: 135px;
        font-family: GT Walsheim Pro;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0.02em;
      }
    }
  }
`;
